"use client"

export default function NotFoundPage() {
	return (
		<div className="max-w-screen-xl mx-auto px-4 flex items-center justify-start h-screen md:px-8">
			<div className="max-w-lg mx-auto flex-1 flex-row-reverse gap-12 items-center justify-between md:max-w-none md:flex">
				<div className="flex-1 max-w-lg">
					<img
						alt="404-Error-amico"
						src="/image/404-amico.webp"
						loading="lazy"
						width={500}
						height={500}
					/>
				</div>
				<div className="mt-12 flex-1 max-w-lg space-y-3 md:mt-0 ">
					<h3 className="text-primary font-semibold text-center text-4xl sm:text-5xl sm:text-left">
						404 Error
					</h3>
					<p className="text-gray-800 text-xl font-semibold text-center sm:text-2xl sm:text-left">
						Page Not Found
					</p>
					<p className="text-gray-600 text-center sm:text-left">
						Sorry, the page you are looking for could not be found or has been
						removed.
					</p>
					<div className="text-center sm:text-left">
						<a
							href="/"
							className="bg-primary text-white px-8 py-3 rounded-full duration-150 hover:text-indigo-400 font-medium inline-flex items-center gap-x-1"
						>
							<div className="flex items-center gap-x-1">
								Go Back Home
								{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									fill="currentColor"
									className="w-5 h-5"
								>
									<path d="M11.47 3.84a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06l6-6-6-6a.75.75 0 010-1.06z" />
								</svg>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	)
}
